import Service from "../../services";

// initial state
const power_bi = {
  name: "power_bi",
  stateFactory: true,
  namespaced: true,
  state: {
    powerBiDataOverviewInternational: [],
    powerBiDataOverviewCountry: [],
    powerBiDataInternational: [],
    powerBiDataCountry: [],
    powerBiDataDefault: [],
    powerBiDataCategory: [],
  },
  getters: {},
  mutations: {
    SET_POWER_BI(state, data) {
      state.powerBiDataOverviewInternational = [];
      state.powerBiDataOverviewCountry = [];
      state.powerBiDataInternational = [];
      state.powerBiDataCountry = [];
      state.powerBiDataDefault = [];
      state.powerBiDataCategory = [];

      data.forEach((item) => {
        switch (item.page) {
          case "Overview-International":
            state.powerBiDataOverviewInternational = [
              ...state.powerBiDataOverviewInternational,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
          case "Overview-Country":
            state.powerBiDataOverviewCountry = [
              ...state.powerBiDataOverviewCountry,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
          case "International":
            state.powerBiDataInternational = [
              ...state.powerBiDataInternational,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                title_th: item.title_th,
                title_en: item.title_en,
                link: item.link,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
          case "Country":
            state.powerBiDataCountry = [
              ...state.powerBiDataCountry,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                title_th: item.title_th,
                title_en: item.title_en,
                subject: item.subject,
                link: item.link,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
          case "DataAndStatic-Default":
            state.powerBiDataDefault = [
              ...state.powerBiDataDefault,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                title_th: item.title_th,
                title_en: item.title_en,
                link: item.link,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
          case "DataAndStatic-Category":
            state.powerBiDataCategory = [
              ...state.powerBiDataCategory,
              {
                description_th: item.description_th,
                description_en: item.description_en,
                embed_url_th: item.embed_url_th,
                embed_url_en: item.embed_url_en,
                subject_en: item.subject_en,
                subject_th: item.subject_th,
                title_th: item.title_th,
                title_en: item.title_en,
                link: item.link,
                id: item.id,
                page: item.page,
                name: item.name,
                access_token: item.access_token,
                report_id: item.report_id,
              },
            ];
            break;
        }
      });
      console.log(state.powerBiDataOverviewInternational);
      console.log("state.powerBiDataDefault", state.powerBiDataDefault);
      console.log("state.powerBiDataCategory", state.powerBiDataCategory);
    },
    setPowerBiIndividual(state, payload) {
      state[payload.name] = payload;
    },
  },
  actions: {
    onGetAllPowerBi({ commit }) {
      // const powerBi = await Service.powerBi.getAllPowerBi();
      return Service.power_bi.getAllPowerBi().then((res) => {
        console.log(res);
        commit("SET_POWER_BI", res);
        return res;
      });
    },

    // onAddPowerBi({state},name) {
    //     return Service.powerBi.addPowerBi(state[name]);
    // },
    // eslint-disable-next-line no-unused-vars
    onUpdatePowerBi({ commit }, data) {
      return Service.powerBi.updatePowerBi(data).then((res) => {
        return res;
      });
    },
    // eslint-disable-next-line no-unused-vars
    onDeletePowerBi({ commit }, id) {
      return Service.powerBi.deletePowerBi(id).then((res) => {
        return res;
      });
    },
  },
};
export default power_bi;
